export enum CustomAttributeStatusOption {
  draft = 1,
  published
}

export enum CustomAttributeTypeOption {
  api = 1,
  formula = 2
}

export enum MathOperation {
  add = "+",
  subtract = "-",
  multiply = "*",
  divide = "/",
  power = "^",
  percentage = "%"
}
